module.exports = __webpack_public_path__ + "img/thanks.f70b47f3.png";